<template>

  <v-dialog lazy v-model="dialog" width="50em">
    <template v-slot:activator="{ on }">
      <v-btn icon color="primary"  v-on="on"><v-icon>fas fa-map-marked-alt</v-icon></v-btn>
    </template>

    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <GmapMap :center="g_coordinates" :zoom="g_zoom" map-type-id="terrain" style="height: 300px">
        <gmap-marker :position="g_coordinates"></gmap-marker>
      </GmapMap>
    </v-card>

  </v-dialog>




</template>

<script>
// import * as VueGoogleMaps from 'vue2-google-maps'

  export default {
    props : {
      center: null,
      zoom: null,
    },
    data () {
      return {
        dialog:false,
        g_coordinates: {lat:0,lng:0},
        g_zoom: 15,
      }
    },
    mounted () {
      this.g_coordinates = this.center;
      this.g_zoom = this.zoom;
    },
    methods : {

    }

  }
</script>
